import { useCallback } from "react"

import { ROOT_SCROLLABLE_ELEMENT } from "../../../utils/constants"
import useBreakpoint from "../../../utils/hooks/use-breakpoint"

export const HERO_FORM = "HERO_FORM"
export const getHeroFormElement = () => {
  return document.querySelector(`#${HERO_FORM}`)
}

export const useScrollToHeroForm = () => {
  const { isSmallBreakpoint } = useBreakpoint()
  const scrollToHeroForm = useCallback(() => {
    if (isSmallBreakpoint) {
      const heroFormElement = getHeroFormElement()
      if (heroFormElement) {
        heroFormElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
        return
      }
    }
    const scrollableElement = document.querySelector(
      `#${ROOT_SCROLLABLE_ELEMENT}`,
    )
    if (scrollableElement) {
      scrollableElement.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }, [isSmallBreakpoint])
  return scrollToHeroForm
}
